import React, { useEffect, useState } from 'react';
import { DashboardHeader } from '@/shared/infra/ui/components/custom-ui/dashboard_header/DashboardHeader';
import { DashboardSidebar } from '@/shared/infra/ui/components/custom-ui/dashboard_sidebar/DashboardSidebar';
import { Outlet } from 'react-router-dom';

const GlobalLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Prevent background scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleSidebarToggle = () => {
    // On mobile, toggle the mobile menu
    // On desktop, toggle the collapsed state
    if (window.innerWidth < 768) {
      setMobileMenuOpen((prev) => !prev);
    } else {
      setSidebarCollapsed((c) => !c);
    }
  };

  return (
    <div className="flex flex-col h-screen w-screen bg-white overflow-hidden">
      <DashboardHeader onSidebarToggle={handleSidebarToggle} sidebarCollapsed={sidebarCollapsed} />
      <div className="flex flex-1 relative h-full w-full overflow-hidden">
        {/* Desktop Sidebar - hidden on mobile (md and below) */}
        <div className="hidden md:block">
          <DashboardSidebar collapsed={sidebarCollapsed} />
        </div>

        {/* Mobile Overlay Sidebar - shown only on mobile when menu is open */}
        {mobileMenuOpen && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-black/50 z-40 md:hidden top-14"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Close menu"
            />
            {/* Overlay Sidebar - positioned below header */}
            <div className="fixed left-0 top-14 bottom-0 z-50 md:hidden">
              <DashboardSidebar collapsed={false} />
            </div>
          </>
        )}

        <main className="flex-1 p-4 bg-white w-full overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default GlobalLayout;